import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { IoHeart } from 'react-icons/io5';
import './LikeAnimation.css';
import { playLikeSound } from '../utils/sounds';

export default function LikeAnimation({ liked, onLike }) {
  const [particles, setParticles] = useState([]);

  const handleClick = () => {
    if (!liked) {
        playLikeSound();
      const newParticles = Array.from({ length: 6 }, (_, i) => ({
        id: Date.now() + i,
        angle: (360 / 6) * i,
      }));
      setParticles(newParticles);
      setTimeout(() => setParticles([]), 600);
    }
    onLike();
  };

  return (
    <div className="like-anim-wrapper">
      <motion.button
        className={'like-anim-btn ' + (liked ? 'like-anim-active' : '')}
        onClick={handleClick}
        whileTap={{ scale: 0.7 }}
      >
        <motion.div
          animate={liked ? { scale: [1, 1.4, 1] } : {}}
          transition={{ duration: 0.3 }}
        >
          <IoHeart />
        </motion.div>
      </motion.button>

      <AnimatePresence>
        {particles.map(p => (
          <motion.div
            key={p.id}
            className="like-particle"
            initial={{ scale: 0, x: 0, y: 0, opacity: 1 }}
            animate={{
              scale: [0, 1, 0.5],
              x: Math.cos(p.angle * Math.PI / 180) * 30,
              y: Math.sin(p.angle * Math.PI / 180) * 30,
              opacity: [1, 1, 0],
            }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          />
        ))}
      </AnimatePresence>
    </div>
  );
}